import { memo } from 'react';
import { cn } from '../../utils/cn';
import {
  accessLabel,
  badgeClass,
  channelLabel,
  phaseLabel,
  reportSourceLabel,
  reportStatusLabel,
  tierLabel,
  type StatusLabel,
} from '../../utils/partnerStatus';

interface PartnerBadgeProps {
  status: StatusLabel;
  /** Leading status dot, for states rather than categories. */
  dot?: boolean;
  /** Extra sentence appended to the hover text (e.g. the bot's detail). */
  detail?: string | null;
  className?: string;
}

/** One Partner Hub state as a badge, with its meaning on hover. */
export const PartnerBadge = memo(({ status, dot = false, detail, className }: PartnerBadgeProps) => (
  <span className={cn(badgeClass(status.tone), dot && 'badge-dot', 'whitespace-nowrap', className)} title={detail ? `${status.hint} ${detail}` : status.hint}>
    {status.label}
  </span>
));
PartnerBadge.displayName = 'PartnerBadge';

export const PartnerPhaseBadge = ({ phase, reason, className }: { phase: string | null | undefined; reason?: string | null; className?: string }) => (
  <PartnerBadge status={phaseLabel(phase)} dot detail={reason} className={className} />
);

export const PartnerTierBadge = ({ tier, className }: { tier: string | null | undefined; className?: string }) => (
  <PartnerBadge status={tierLabel(tier)} className={className} />
);

export const PartnerAccessBadge = ({ state, detail, className }: { state: string | null | undefined; detail?: string | null; className?: string }) => (
  <PartnerBadge status={accessLabel(state)} dot detail={detail} className={className} />
);

export const PartnerChannelBadge = ({ state, className }: { state: string | null | undefined; className?: string }) => (
  <PartnerBadge status={channelLabel(state)} dot className={className} />
);

export const ReportStatusBadge = ({ status, className }: { status: string | null | undefined; className?: string }) => (
  <PartnerBadge status={reportStatusLabel(status)} dot className={className} />
);

export const ReportSourceBadge = ({ source, className }: { source: string | null | undefined; className?: string }) => (
  <PartnerBadge status={reportSourceLabel(source)} className={className} />
);
